/*jshint esversion: 6 */
import * as paragrGetter from "./ParagraphGetter.js";
import axios from 'axios';
import * as funcs from "../utils/showFuncs.js";
import * as ppFuncs from "../utils/PageParagraphFuncs.js";

import apiRouteNames from "../API_routes/routeFuncs";
const postPagesUrl = apiRouteNames.pageRoute;

console.log('postPagesUrl', postPagesUrl);

const putErrorET = "Lehekülje uundamine ei õnnestunud. ";
const postErrorET = "Lehekülje pärimine ei õnnestunud. ";
const getErrorET = "Lehekülje pärimine ei õnnestunud. ";
const deleteErrorET = "Lehekülje kustutamine ei õnnestunud. ";

//display
export function getAllPagesWithoutFooter(self) {
    axios.get( postPagesUrl)
        .then(function (response) {
            var allPagesData = response.data;
            //console.log('GET PAGES response.data', pageData);
            //sort by order
            if(allPagesData){
                let pagesWithoutFooter = allPagesData.filter(p => !p.isFooter);
                pagesWithoutFooter.sort(function (a, b) {
                    return a.order - b.order;
                });
                //console.log('GET DISPLAY PAGES', allPagesData);
                //set collection to state
                pagesWithoutFooter.map(page  => {                               
                    ppFuncs.sanitazePageOrderPair(page, page.paragraphs, self);
                });
                self.setState ({pages: pagesWithoutFooter} );
            }    
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}

export function getAllPages_SeparatelyFooter(self) {
    axios.get( postPagesUrl)
        .then(function (response) {
            var allPagesData = response.data;
            //console.log('GET PAGES response.data', pageData);
            //sort by order
            if(allPagesData){
                let pagesWithoutFooter = allPagesData.filter(p => !p.isFooter);
                pagesWithoutFooter.sort(function (a, b) {
                    return a.order - b.order;
                });
               
                let footerData = allPagesData.filter(p => p.isFooter);
                footerData.sort(function (a, b) {
                    return a.order - b.order;
                });
                
                //console.log('GET DISPLAY PAGES footerData', footerData);
                self.setState ({pages: pagesWithoutFooter, footer: footerData} );
            }    
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}

export function getAllPages_SeparatelyFooter_PlusSubObjects(self) {
    axios.get( postPagesUrl)
        .then(function (response) {
            var allPagesData = response.data;
            //console.log('GET PAGES response.data', pageData);
            //sort by order
            if(allPagesData){
                let pagesWithoutFooter = allPagesData.filter(p => !p.isFooter);
                pagesWithoutFooter.sort(function (a, b) {
                    return a.order - b.order;
                });
               
                let footerData = allPagesData.filter(p => p.isFooter);
                footerData.sort(function (a, b) {
                    return a.order - b.order;
                });
                
                //console.log('GET DISPLAY PAGES footerData', footerData);
                self.setState ({pages: pagesWithoutFooter, footer: footerData} );
                getPageParagraphs(footerData);
                getPageParagraphs(pagesWithoutFooter);
            }    
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}


export function getPageParagraphs(pageObj){
    let footersParagArray = [];
    //console.log('getPageParagraphs: footerParags ', footerParags);
    pageObj.forEach(fObj => {
        let fParArr = fObj.paragraphs;
        if(fParArr.length){
            paragrGetter.getParagraphByIdArray(fParArr, fObj);
        }
    });
  }


export function getAllPages(self, includeHierarchies = false) {
    axios.get( postPagesUrl)
        .then(function (response) {
            var allPagesData = response.data;
            //console.log('GET PAGES response.data', pageData);
            //sort by order
            allPagesData.sort(function (a, b) {
                return a.order - b.order;
            });
            //console.log('GET DISPLAY PAGES', allPagesData);
            //set collection to state
            allPagesData.map(page  => {                               
                ppFuncs.sanitazePageOrderPair(page, page.paragraphs, self);
            });
            self.setState ({shareholders: allPagesData} );

            //if we are at the page of adding subpages
            /*
            let newRelation = {
                parentId : _parentId,
                subpages : [3, 5, 6]
            }
            */
            if(includeHierarchies){
                let initHierarchies = [];
                allPagesData.map((pagedata) =>{
                    let newRelation = {
                        parentId : pagedata._id,
                        subpages : pagedata.subpages};
                    initHierarchies.push(newRelation);
                });
                self.setState({pageHierarchy : [].concat(initHierarchies)});
            }
                
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}


// WEBPACK FOOTER //
// ./src/Controllers/PageGetter.js